/* eslint-disable no-underscore-dangle */
import { getCookie, setCookie } from './cookies';

/**
 * Identify customer at customer io.
 * @param data - {object} Form data.
 */
export default function cioIdentify(data) {
  const time = Math.round(new Date().getTime() / 1000);
  const language = window.navigator.userLanguage || window.navigator.language || 'N/A';
  const cioData = Object.assign(data, {
    id: data.email,
    created_at: time,
    source: data.lead_source,
    interest: data['00NA0000001qHx1'],
    language
  });
  delete cioData.oid;
  delete cioData.sfga;
  delete cioData.retURL;
  delete cioData.lead_source;
  delete cioData['00NA0000001qHx1'];

  try {
    setCookie('cio_fallback', JSON.stringify(cioData), 30, '.anychart.com');
  } catch (err) {
    window.console.log('failed to make cio fallback');
  }

  window._cio.identify(cioData);
}

// send data to cio each time page loaded
document.addEventListener('DOMContentLoaded', () => {
  try {
    const cioFallbackData = getCookie('cio_fallback');
    if (cioFallbackData) {
      const iid = setInterval(() => {
        if (window._cio) {
          clearInterval(iid);
          window._cio.identify(JSON.parse(cioFallbackData));
        }
      }, 500);
    }
  } catch (err) {
    window.console.log('failed to make cio fallback');
  }
});
